export default "__VITE_ASSET__GIXq3s0H__"